<template>
  <div class="collection-item-box" @click="$modal.open('shop', shop)">
    <h2 class="truncate" v-text="shop.name"></h2>
    <hr>
    <div class="flex justify-between">
      <vue-tag icon="note-list-solid">{{ shop.orders_count || 0 }} {{ shop.orders_count > 1 ? 'commandes' : 'commande' }}</vue-tag>
      <vue-tag class="font-mono tracking-wide" icon="barcode-solid">{{ shop.code}}</vue-tag>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    shop: {
      type: Object,
      required: true,
    },
  },
};
</script>